import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { NgxSpinnerService } from 'ngx-spinner';
import { PassholdersWatchlistService } from 'src/app/core/services/passholders-watchlist/passholders-watchlist.service';

@Component({
  selector: 'app-passholders-watchlist',
  templateUrl: './passholders-watchlist.component.html',
  styleUrls: ['./passholders-watchlist.component.css']
})
export class PassholdersWatchlistComponent implements OnInit {

  showSideBar: boolean = false;
  events: any[] = [];
  selectedEventType: string = '';
  selectedButton: string = 'ALL';
  timezone: any;

  constructor(
    private _location: Location,
    private routerurl: Router,
    private watchlistService: PassholdersWatchlistService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.fetchEvents();
  }
  
  openSideBar() {
    this.showSideBar = !this.showSideBar;
  }

  backClicked() {
    if (window.history.length > 1) {
      this._location.back();
    } else {
      this.routerurl.navigateByUrl(`/cinejoy/showcase`)
    }
  }

  fetchEvents(eventType: string = ''): void {
    this.watchlistService.getPassholdersWatchlist(eventType).subscribe((response) => {
      this.events = (response || []).sort((a, b) => Number(b.isMustSee) - Number(a.isMustSee));
    });
  }

  userTimezoneNameSP(date: any) {
      var zone = moment.tz.guess();
      var newDate = new Date(date).toString()
      var timezoneName = moment(newDate).tz(zone).format('z')
      return timezoneName;
  }

  deleteEvent(event: any): void {
    this.spinner.show();
    const res = window.confirm("Do you want to delete this event from your Watchlist?")
    if(res){
      this.watchlistService.delete(event.eventDetails.eventId, event.userId, event.eventType).subscribe((response) => {
        alert('Event deleted successfully!');
        this.spinner.hide();
        this.fetchEvents();
      },
      (err)=> {
        alert('Failed to delete event. Please try again.');
        this.spinner.hide();
      }
      )
    } 
    else {
      this.spinner.hide();
    }
  }

  selectButton(category: string) {
    this.selectedButton = category;
    this.fetchEvents(category);
  }

  UpdatePassholderWatchlist(eventId: number, isMustSee: boolean, eventType: any): void {
    this.spinner.show();

    this.watchlistService.UpdatePassholderWatchlist(eventId, isMustSee, eventType).subscribe((res) => {
      if(res){
        alert('Watchlist updated successfully!');
        this.spinner.hide();
        this.fetchEvents();
      }
    });
  }

  toggleDescription(event: any): void {
    if(event.eventType === "SHOWCASE"){
      let name = event.eventDetails.eventName.replace(/ /g, '-');
      const url = this.routerurl.serializeUrl(
        this.routerurl.createUrlTree([`/cinejoy/showcase/moviepage/${event.eventDetails.eventId}/${name}/${event.eventDetails.cinejoyYears}`])
      );
      window.open(url, '_blank');
    } else if(event.eventType === "SPOTLIGHT") {
      let name = event.eventDetails.eventName.replace(/ /g, '-');
      const url = this.routerurl.serializeUrl(
      this.routerurl.createUrlTree([`/cinejoy/premiere/more-info/${event.eventDetails.eventId}/${name}`])
      );
      window.open(url, '_blank');
    } else if(event.eventType === "SYMPOSIUM"){
      const url = this.routerurl.serializeUrl(
        this.routerurl.createUrlTree([`/symposiums/more-details/${event.eventDetails.eventId}`])
      );  
      window.open(url, '_blank');
    }  else if(event.eventType === "SCREENING_PARTY"){
      const url = this.routerurl.serializeUrl(
        this.routerurl.createUrlTree([`/symposiums/more-details/${event.eventDetails.eventId}`])
      );  
      window.open(url, '_blank');
    }
  }

  showDescription(event: any): void {
      event.showOverlay = true;
  }

  hideDescription(event: any): void {
      event.showOverlay = false;
  }

  navigateTo(eventType: string): void {
    switch (eventType) {
      case 'SPOTLIGHT':
        this.routerurl.navigateByUrl('/cinejoy/premiere/lineup');
        break;
      case 'SHOWCASE':
        this.routerurl.navigateByUrl('/cinejoy/showcase');
        break;
      case 'SCREENING_PARTY':
        this.routerurl.navigateByUrl('/cinejoy/meetup/join');
        break;
      case 'SYMPOSIUM':
        this.routerurl.navigateByUrl('/symposiums/lineup');
        break;
    }
  }

}
